<template>
  <div class="freeApplyApply">
    <Header title="申请"></Header>
    <div class="train">
      <div class="list-head">
        <p>{{ list.kcmc }}[{{ list.kch }}]</p>
        <van-row>
          <van-col span="12">
            <ul>
              <li>学年学期：{{ list.xqmc }}</li>
              <li>上课老师：{{ list.skls }}</li>
            </ul>
          </van-col>
          <van-col span="12">
            <ul>
              <li>成绩录入人：{{ list.cjlrr }}</li>
              <li>修读类型：{{ list.xdlx }}</li>
            </ul>
          </van-col>
          <van-col span="24">
            <ul>
              <li>开课单位：{{ list.ksdw }}</li>
              <li>上课时间：{{ list.kcsj }}</li>
            </ul>
          </van-col>
        </van-row>
      </div>
      <p class="title">冲突信息</p>
      <van-field
        v-if="params.ck != '1'"
        v-model="cjxm.mc"
        label="成绩项目"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="onShow('成绩项目', 'cjxm')"
        readonly
      />
      <div class="list-head">
        <p>{{ classList.kcmc }}[{{ classList.kch }}]</p>
        <van-row>
          <van-col span="24">
            <ul>
              <li>开课单位：{{ classList.ksdw }}</li>
              <li>冲突信息：{{ classList.kcsj }}</li>
            </ul>
          </van-col>
        </van-row>
      </div>
      <van-field
        v-if="params.ck != '1'"
        v-model="shr.mc"
        label="审核人"
        right-icon="arrow"
        input-align="right"
        placeholder="请点击选择"
        @click="show1 = true"
        readonly
      />
      <van-field
        v-model="sqyy"
        rows="1"
        autosize
        label="申请原因"
        type="textarea"
        maxlength="200"
        placeholder="请点击填写"
        :readonly="params.ck == '1' ? true : false"
      />
      <van-checkbox
        v-if="params.ck == '1'"
        shape="square"
        checked-color="#7469f8"
        v-model="checked"
        disabled
      >
        <span class="warn">
          我已知悉：办理免听手续后，学生原则上需按照任课教师的要求进行自学，并完成作业、测验等学习环节，方可取得参加课程考核的资格；未按任课教师要求完成上述学习环节的，不具有考核资格。
        </span>
      </van-checkbox>
    </div>
    <div v-if="params.ck != '1'" class="bottom-btn">
      <van-checkbox shape="square" checked-color="#7469f8" v-model="checked">
        <span class="warn">
          我已知悉：办理免听手续后，学生原则上需按照任课教师的要求进行自学，并完成作业、测验等学习环节，方可取得参加课程考核的资格；未按任课教师要求完成上述学习环节的，不具有考核资格。
        </span>
      </van-checkbox>
      <button @click="save()">保存并送审</button>
    </div>
    <!-- <div class="bottom-btn1">
      <button @click="save()">保存并送审</button>
      <button @click="del()">删除</button>
    </div> -->
    <van-popup v-model="show" round position="bottom">
      <van-picker
        :title="valueList.label"
        show-toolbar
        :columns="valueList.item"
        @cancel="show = false"
        @confirm="
          (value, index) => {
            onConfirm(value, index, valueList.value);
          }
        "
      />
    </van-popup>
    <van-popup v-model="show1" position="bottom">
      <div class="apply-pop">
        <div class="pop-title">
          <i class="close-icon" @click="show1 = false"></i>
          <p>审核人</p>
          <i class="confirm-icon" @click="resetCancel()"></i>
        </div>
        <div class="person">
          <button
            class="per-btn"
            ref="person"
            v-for="(item, index) in shrList"
            @click="personTap($event, index)"
            :key="item.id"
          >
            {{ item.name }}
          </button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Api } from "../../../../utils/axios";
export default {
  data() {
    return {
      show: false,
      cjxm: {},
      sqyy: "",
      list: [],
      classList: [],
      params: [],
      columns: {},
      valueList: {
        label: "",
        value: "",
        item: []
      },
      checked: false,
      shr: {},
      show1: false,
      shrList: [
        {
          id: "",
          name: "全部",
          isBtn: 0
        }
      ]
    };
  },
  created() {
    this.params = this.$route.query.list;
    this.getList();
    if (this.params.ck != "1") {
      this.getShr();
    } else {
      this.checked = true;
    }
  },
  methods: {
    async save() {
      if (JSON.stringify(this.shr) == "{}") {
        this.$toast.fail("请选择送审审核人!");
        return;
      }
      if (this.checked == false) {
        this.$toast.fail("我已知悉勾选才可保存并送审!");
        return;
      }
      if (this.sqyy == "") {
        this.$toast.fail("请填写完整申请原因!");
        return;
      }
      const res = await Api.savemtsq({
        ctjx0404id: this.cjxm.dm,
        jx0404id: this.list.jx0404id,
        userids: this.shr.dm,
        sqyy: this.sqyy
      });
      if (res.code == 1) {
        // if (this.params.ck == "0") {
        //   this.$toast.success("修改成功!");
        // } else {
        //   this.$toast.success("保存并送审成功!");
        // }
        this.$toast.success("保存并送审成功!");

        setTimeout(() => {
          this.$router.replace("/freeApply/index");
        }, 1500);
      } else {
        this.$toast.fail(res.Msg);
      }
    },
    async getData() {
      const res = await Api.mtsqCtxx({
        ctjx0404id: this.cjxm.dm,
        jx0404id: this.list.jx0404id
      });
      this.classList = res.data;
    },
    async getList() {
      const res = await Api.mtsqKcmx({
        jx0404id: this.params.jx0404id,
        id: this.params.id
      });
      if (res.code == "0") {
        this.$toast(res.Msg);
        setTimeout(() => {
          this.$router.back();
        }, 2000);
      } else {
        this.list = res.data.kcxx[0];
        if (this.params.ck == "1") {
          this.sqyy = this.list.sqyy;
        }
        this.columns.cjxm = res.data.cttzd.map((item, index) => {
          if (index == 0) {
            this.cjxm = {
              mc: "冲突课程" + (index + 1),
              dm: item.ctjx0404id
            };
          }
          return {
            text: "冲突课程" + (index + 1),
            value: item.ctjx0404id
          };
        });
      }
      this.getData();
    },
    // 弹出选择器
    onShow(label, value) {
      this.show = true;
      this.valueList.label = label;
      this.valueList.value = value;
      this.valueList.item = this.columns[value];
    },
    onConfirm(value, index, value1) {
      this.show = false;
      this[value1].mc = value.text;
      this[value1].dm = value.value;
      if (value1 == "cjxm") {
        this.getData();
      }
    },
    async getShr() {
      let concatList2 = [];
      let concatList3 = [];
      const params = {
        ywcode: "923",
        ywid: ""
      };
      const res = await Api.selectReviewerApi(params);
      res.data.forEach((item, index) => {
        concatList2[index] = {
          name: item.userrealname,
          id: item.userid,
          isBtn: 0
        };
      });
      this.shrList = this.shrList.concat(concatList2);
    },
    // 审核人弹框中的按钮选择
    personTap(e, res) {
      let strList = [];
      let idList = [];
      if (this.shrList[res].isBtn == 0) {
        this.shrList[res].isBtn = 1;
        e.target.className = "cur";
      } else if (this.shrList[res].isBtn == 1) {
        this.shrList[res].isBtn = 0;
        e.target.className = "per-btn";
      }
      for (let i in this.shrList) {
        if (this.shrList[res].name == "全部") {
          this.shrList[i].isBtn = 0;
          this.shrList[res].isBtn = 1;
          this.$refs.person[res].className = "cur";
          this.$refs.person[i].className = "per-btn";
        } else {
          this.shrList[0].isBtn = 0;
          this.$refs.person[0].className = "per-btn";
        }
        if (this.shrList[i].isBtn == 1) {
          strList = strList.concat(this.shrList[i].name);
          idList = idList.concat(this.shrList[i].id);
        }
      }
      this.reset = strList.toString();
      this.resetId = idList.toString();
    },
    // 审核人选择完后点击确认
    resetCancel() {
      this.show1 = false;
      this.shr.mc = this.reset;
      this.shr.dm = this.resetId;
    }
  }
};
</script>
<style lang="less" scoped>
.freeApplyApply .train {
  padding: 5% 5% 0;
  height: 90vh;
  padding-bottom: 150px;
  box-sizing: border-box;
  overflow: auto;
  .list-head {
    background-image: url("../../../../../static/image/head.png");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    display: flex;
    padding: 6% 7%;
    box-sizing: border-box;
    margin-bottom: 5%;
    position: relative;
    flex-direction: column;
    p {
      font-family: PingFangSC-Medium;
      font-size: 16px;
      color: #fff;
      letter-spacing: 0;
      margin-bottom: 2%;
      font-weight: bold;
    }
    ul li {
      font-family: PingFangSC-Light;
      font-size: 12px;
      color: #fff;
      letter-spacing: 0;
      margin-bottom: 1%;
      font-weight: lighter;
    }
    span {
      position: absolute;
      top: 15%;
      right: 7%;
      color: #fff;
      border-radius: 40%;
      font-size: 14px;
      padding: 1% 3%;
      background-color: #8f87f9;
    }
  }
  .title {
    font-family: PingFangSC-Medium;
    font-size: 20px;
    letter-spacing: 0;
    margin-bottom: 2%;
    text-align: center;
    font-weight: bold;
  }
  .van-cell {
    padding: 10px 0;
    border-bottom: 1px solid #f4f4f4;
  }
  .van-cell::after {
    display: none;
  }
  .van-field__label {
    width: 7.2em;
  }
  .van-cell.van-field .van-cell__title.van-field__label > span {
    font-family: PingFangSC-Light;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
  }
  .van-field__control::-webkit-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    letter-spacing: 0;
    font-weight: normal;
    text-align: right;
  }
  .van-field__control::-moz-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    font-weight: normal;
    letter-spacing: 0;
    text-align: right;
  }
  .van-field__control::-ms-input-placeholder {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #dfe0e6 !important;
    letter-spacing: 0;
    font-weight: normal;
    text-align: right;
  }
  .van-field__control {
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #212f6e;
    letter-spacing: 0;
    text-align: right;
    font-weight: bolder;
  }
  .van-icon-arrow {
    color: #dfe0e6;
    font-weight: bolder;
    font-size: 14px;
  }
}
/* 审核人 */
.close-icon {
  background: url(../../../../../static/img/close.png) no-repeat center;
}
.confirm-icon {
  background: url(../../../../../static/img/confirm.png) no-repeat center;
}
.pop-title i {
  width: 22px;
  height: 22px;
  background-size: 22px 22px;
  padding: 10px;
}
.pop-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.person {
  padding: 15px;
}
.person button {
  border-radius: 3px;
  padding: 5px 15px;
  margin-right: 12px;
  margin-bottom: 10px;
}
.apply-pop .person .per-btn {
  background-color: #ecedfd;
  color: #7469f8;
}
.person .cur {
  background-color: #7469f8;
  color: #ecedfd;
}

.bottom-btn {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 160px;
  padding: 0 5%;
  padding-bottom: 20px;
  background: #fff;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  button {
    width: 100%;
    height: 44px;
    background: #7469f8;
    border-radius: 3px;
    color: #fff;
  }
}
.warn {
  color: red;
  font-size: 12px;
  line-height: 0;
}
.bottom-btn1 {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
  padding-bottom: 10px;
  padding: 0 5%;
  background: #fff;
  box-sizing: border-box;

  button:first-child {
    width: 47.5%;
    height: 44px;
    background: #ecedfd;
    border-radius: 3px;
    color: #7469f8;
  }
  button:last-child {
    width: 47.5%;
    height: 44px;
    background: #7469f8;
    border-radius: 3px;
    color: #fff;
    float: right;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/freeApply/apply.vue